export const INSURANCE_INTAKE_CONSENT_CODE = "insurance-intake-v1";
export const INSURANCE_INTAKE_CONSENT_TEXT = "Chiedo di essere ricontattato o di ricevere l’analisi della polizza RC professionale e acconsento al trattamento dei dati forniti esclusivamente per questa richiesta assicurativa.";
export const INSURANCE_INTAKE_CONSENT_SHA256 = "a229d39c8d355f2cc79bae7aa95a1d5a7380b7b8fa562aba8eded2ceb56162e5";
export const INSURANCE_POLICY_MAX_BYTES = 10 * 1024 * 1024;
export const INSURANCE_POLICY_BUCKET = "insurance-policy-intake";
export const INSURANCE_TURNSTILE_ACTION = "insurance_intake";

export function policyUploadReceiptMessage(
  leadId: string,
  policyFileId: string,
  contentSha256: string,
  byteLength: number,
): string {
  return `policy-upload-receipt-v1:${leadId}:${policyFileId}:${contentSha256}:${byteLength}`;
}
